/**
 * @fileoverview POST handler for the "/engagement/campaigns/:app_group_id/update_enabled_state" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementCampaignsAppGroupIdUpdateEnabledStateCacheKeys } from "./constants";
import type {
  PostEngagementCampaignsAppGroupIdUpdateEnabledStateProps,
  EngagementCampaignsAppGroupIdUpdateEnabledStateResult,
} from "./types";

export const postEngagementCampaignsAppGroupIdUpdateEnabledState = reactQueryMutationAdapter(
  engagementCampaignsAppGroupIdUpdateEnabledStateCacheKeys,
  (
    props: PostEngagementCampaignsAppGroupIdUpdateEnabledStateProps
  ): Promise<EngagementCampaignsAppGroupIdUpdateEnabledStateResult> => {
    return fetch(`/engagement/campaigns/${props.app_group_id}/update_enabled_state`, "POST", props);
  }
);
